import { render, staticRenderFns } from "./MISClassContainer.vue?vue&type=template&id=3807c876&scoped=true&lang=pug"
import script from "./MISClassContainer.vue?vue&type=script&lang=js"
export * from "./MISClassContainer.vue?vue&type=script&lang=js"
import style0 from "./MISClassContainer.vue?vue&type=style&index=0&id=3807c876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807c876",
  null
  
)

export default component.exports